<template>
	<setup
		title="Confirm Your Work Identity"
		:error="error"
		:success="success"
		:onMounted="initializeControls">
		<form class="card-body" method="post" @submit.prevent="handleFormSubmit">
			<div style="text-align: center; padding: 20px 0 32px" v-if="initializing">
				<appIcons asset="loader" />
			</div>
			<div
				class="default-form w-border"
				style="text-align: center; margin: auto"
				v-if="!initializing">
				<div class="form-row label">
					<div class="form-label">Company</div>
					<select
						id="company"
						v-model="company"
						v-bind:disabled="companies === null"
						:class="{'no-value-selected': company === null}"
						@change="setRolePickList"
						name="company">
						<option value="null" disabled selected>Select your company...</option>
						<option v-for="c in companies" v-bind:value="c.Id" :key="c.Id" v-cloak>
							{{ c.Name.toUpperCase() + " (" + c.Id + ")" }}
						</option>
					</select>
				</div>
				<div class="form-row label" v-if="company !== null" v-cloak>
					<div class="form-label">Role</div>
					<select
						id="userRole"
						v-model="code"
						name="userRole"
						:class="{'no-value-selected': code === null}">
						<option value="null" disabled selected>Select your role...</option>
						<option
							v-for="role in roles"
							v-bind:value="role.EmployeeNo + ',' + role.Code"
							:key="role.Code">
							{{
								(
									(role.LegalEntityName || role.Description || "") +
									(role.LegalEntityName && role.Description ? " // " + role.Description : "")
								).toUpperCase()
							}}
						</option>
					</select>
				</div>
				<div class="mt-4" style="text-align: center">
					<div class="spinner small light" v-show="loading"></div>
					<input
						type="submit"
						value="Continue"
						class="button large blue"
						v-show="!loading"
						v-cloak />
				</div>
			</div>
		</form>
	</setup>
</template>

<script>
	import Setup from "./Setup.vue";
	import AppIcons from "./AppIcons.vue";
	export default {
		name: "Identity",
		data() {
			return {
				error: "",
				success: "",
				loading: false,
				initializing: true,
				companies: null,
				roles: [],
				roleList: [],
				company: null,
				code: null,
			};
		},
		components: {
			Setup,
			AppIcons,
		},
		methods: {
			setRolePickList() {
				if (this.roleList.length > 0) {
					this.code = null;
					const roles = this.roleList.filter((r) => r.CompanyNo === this.company || r.Code === "H");
					this.roles = roles || [];
				}
			},
			handleFormSubmit() {
				const [EmployeeNo, Role] = this.code.split(",");
				let data = {
					Company: this.company,
					EmployeeNo,
					Role,
					RedirectUrl: this.$route.query.redirectUrl,
				};
				this.error = "";
				if (data.Company == "") {
					this.error = "Please select a company.";
				}
				if (data.Role == "") {
					this.error = "Please select a Role.";
				}
				if (this.error != "") return;

				this.loading = true;
				this.reqAuthRedirect(data);
			},
			reqAuthRedirect(data) {
				this.$ajax
					.post("/Roles/authenticated-redirect", data)
					.then((resp) => {
						const {RedirectUrl, Message} = resp.data;
						this.success = Message;
						window.setTimeout(() => {
							window.location.href = RedirectUrl;
						}, 1000);
					})
					.catch((err) => {
						if (err.status == 401) {
							this.$router.push({
								name: "Login",
								query: {redirectUrl: this.$route.query.redirectUrl || undefined},
							});
						}
					})
					.finally(() => {
						this.loading = false;
					});
			},
			async initializeControls() {
				const {Companies, Roles} = await this.$ajax.get("/Roles/details").then((resp) => resp.data);
				this.companies = Companies;
				this.roleList = Roles;
				if (Companies.length === 1 && Roles.length === 1) {
					let data = {
						Company: Companies[0].Id,
						EmployeeNo: Roles[0].EmployeeNo,
						Role: Roles[0].Code,
						RedirectUrl: this.$route.query.redirectUrl,
					};
					this.reqAuthRedirect(data);
				} else {
					this.initializing = false;
					this.companies = Companies;
					if (Companies.length === 1) {
						this.company = Companies[0].Id;
						this.setRolePickList();
					}
				}
			},
		},
	};
</script>

<style scoped>
	.form-label {
		font-size: 18px;
		margin-bottom: 8px;
		line-height: 1.25;
	}

	.newui .section .default-form .form-row {
		margin-bottom: 24px;
	}

	.newui .section .default-form .form-row select {
		width: 100%;
		max-width: 420px;
		font-size: 14px;
		padding: 0 16px;
		text-align: center;
	}

	.newui .section .default-form .form-row select.no-value-selected,
	.newui .section .default-form .form-row select option[value="null"] {
		color: #acacac !important;
	}

	.newui .section .default-form .form-row select.no-value-selected option {
		color: #000;
	}

	.input-radio {
		width: 100%;
		max-width: 420px;
		text-align: left;
		margin: 0 auto 4px;
		display: flex;
	}

	.input-radio input[type="radio"] {
		height: 24px;
		margin: 0 12px 0 0 !important;
	}

	.input-radio input[type="radio"]:focus {
		box-shadow: none !important;
	}

	.input-radio label {
		width: calc(100% - 28px) !important;
	}

	.input-radio label span,
	.input-radio label small {
		display: block;
	}

	.input-radio small {
		color: #9d9d9d;
	}
</style>
